import { styled } from '@mui/material/styles';
import { MOBILE_BREAKPOINT } from '@src/constants';
import { BREAKPOINTS, FLASH_SALE_BANNER_HEIGHT } from '@src/styles/config';
import { Typography } from '@mui/material';
import { COLOR } from '@src/styles/color';

export const StyledTransactionsHistory = styled('div')`
  .transaction-history-card {
    margin: 16px 4px;
    min-height: ${(props) =>
      props.isShowHeaderBanner
        ? `calc(100vh - 48px - ${FLASH_SALE_BANNER_HEIGHT}px)`
        : 'calc(100vh - 48px)'};
    display: flex;

    @media only screen and (max-width: ${MOBILE_BREAKPOINT}) {
      padding: 20px;
      margin: 8px 0;
      display: flex;
      gap: 24px;
    }

    @media only screen and (max-width: ${BREAKPOINTS.MXS}px) {
      padding: 0;
    }
    .vnd {
      text-decoration: underline;
    }
  }

  .transaction-history-loading {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .transaction-history-wrapper {
    display: flex;
    flex-direction: column;
    max-width: 1135px;
    width: 100%;
    margin: 0 auto;
    flex: 1;
  }

  .transaction-history-table {
    padding: 0 24px 24px 24px;
    gap: 24px;
    display: flex;
    flex-direction: column;
    flex: 1;
  }
`;

export const StyledTransactionHistoryHeader = styled('div')`
  display: flex;
  padding: 24px 24px 0 24px;
  gap: 16px;
`;

export const StyledChip = styled(Typography)`
  display: block;
  background-color: ${({ backgroundColor }) =>
    backgroundColor && backgroundColor};
  color: ${({ color }) => color && color};
  padding: 1px 10px;
  border-radius: 17px;
  font-size: 13px;
  font-weight: 500;
  width: fit-content;
  white-space: nowrap;
  text-align: center;
  margin: auto;
`;

export const StyledCancelWithdrawalDialogNote = styled('div')`
  min-height: 40px;
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px;
  border-radius: 8px;
  background-color: ${(props) =>
    props.backgroundColor || COLOR.functionalRed[8]};
  box-sizing: border-box;
  border: 1px solid ${COLOR.functionalRed[16]};
  width: 432px;

  .warning-wrapper {
    background-color: #007aff14 !important;
  }

  .note-icon {
    color: ${COLOR.textRejected};
    width: 20px;
    height: 20px;
  }

  .note-icon-warning {
    color: ${COLOR.alert};
    width: 20px;
    height: 20px;
  }

  .note-text {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: -0.4px;
    vertical-align: middle;
    color: ${COLOR.darkGray};
  }

  @media only screen and (max-width: ${MOBILE_BREAKPOINT}) {
    .note-text {
      font-weight: 400;
      font-size: 12px;
      line-height: 16px;
      letter-spacing: -0.4px;
      vertical-align: middle;
    }
  }
`;

export const StyledEmptyWithdrawalRequest = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  flex: 1;
`;

export const StyledTabs = styled('div')`
  display: flex;
`;
